import { normalizeRates } from "@/utils/shippingUtils";
import api, { fetchV2 } from "@/services/Api";

export const getShapesList = async (options) => {
  const resp = await fetchV2("/store/shapes/?slim=true", options);

  return resp;
};

export const getShopRates = async (options) => {
  const resp = await fetchV2("/store/shop-rates", options);

  return resp;
};

export const getScentsList = async () => {
  const resp = await fetchV2("/store/scents/?stores__id=2");
  return resp
    .map((scent) => {
      if (scent.slug === "no-fragrance") {
        return { ...scent, name: "No Fragrance - No packaging" };
      }
      return scent;
    })
    .sort((scentA, scentB) => {
      if (scentB.slug === "no-fragrance") return 1;
      return scentA.name < scentB.name ? -1 : 1;
    });
};

export const getStringsList = async () => {
  const resp = await fetchV2("/store/strings/");
  return resp;
};

export const createCustomerCard = async ({ nickname, name, is_default, payment_method_id }) => {
  const resp = await api.post("/v2/store/customers/card", {
    nickname,
    name,
    default: is_default,
    payment_method_id,
  });

  return resp.data;
};

export const putCustomerCard = async (
  { name, nickname, postal_code, month, year, is_default },
  cardId
) => {
  const resp = await api.patch(`/v2/store/cards/${cardId}/update`, {
    name,
    nickname,
    address_zip: postal_code,
    exp_month: month,
    exp_year: year,
    default: is_default,
  });

  return resp.data;
};

export const deleteCustomerCard = async (cardId) => {
  const resp = await api.delete(`/v2/store/cards/${cardId}/delete`);

  return resp.data;
};

export const createShippingRatesPreview = async ({ postal_code, country }) => {
  const resp = await api.post(`/v2/store/customers/location/preview`, {
    postal_code,
    country,
  });

  return resp.data;
};

export const retrieveShippingRatesPreview = async ({ preview_id, order_id }) => {
  const resp = await api.get(`/v2/store/orders/${order_id}/location/${preview_id}/rates`);

  return normalizeRates(resp.data);
};

export const retrieveShippingQuotes = async ({ orderId }) => {
  const resp = await api.get(`/v2/store/orders/${orderId}/quotes`);
  return {
    ...resp.data,
    rates: resp.data.rates && normalizeRates(resp.data.rates),
  };
};

export const refreshShippingQuotes = async ({ orderId }) => {
  const resp = await api.post(`/v2/store/orders/${orderId}/refresh_quotes`);

  return resp.data;
};

export const postShipment = async ({ location_id, order_id }) => {
  const resp = await api.post(`/v2/store/orders/${order_id}/location/${location_id}`);

  return resp.data;
};

export const putShipmentRate = async ({ shipping_quote, shipping_method, order_id }) => {
  const resp = await api.put(`/v2/store/orders/${order_id}/shipping/update`, {
    shipping_quote,
    shipping_method,
  });

  return resp.data;
};

export const completePayment = async ({ id, amount, card, payment_intent_id }) => {
  const resp = await api.post(`/v2/store/orders/${id}/payment`, {
    amount,
    card,
    payment_intent_id,
  });

  return resp.data;
};

export const completePaypalPayment = async ({ id, amount, paypal }) => {
  const resp = await api.post(`/v2/store/orders/${id}/paypal/payment`, {
    amount,
    paypal,
  });

  return resp.data;
};

export const completeAmazonPayment = async ({ id, amount, payment_intent_id }) => {
  const resp = await api.post(`/v2/store/orders/${id}/amazon/payment`, {
    amount,
    payment_intent_id,
  });

  return resp.data;
};

export const createPaymentIntent = async ({ id, payment_method_type }) => {
  const resp = await api.post(`/v2/store/orders/${id}/payment_intent`, {
    payment_method_type,
  });

  return resp.data;
};

export const createShippingPreview = async ({ id, address }) => {
  const resp = await api.post(`/v2/store/orders/${id}/shipping-rates-preview`, {
    address,
  });

  return normalizeRates(resp.data);
};

export const updateShippingPreviewRates = async ({ id, shipping_option_preview }) => {
  const resp = await api.put(`/v2/store/orders/${id}/shipping-option-preview/update`, {
    shipping_option_preview,
  });

  return resp.data;
};
